import type {
  ApprovalRequest,
  ApprovalRequestResponseDto,
  ApprovalRequestsControllerFindAllData,
} from '@carvia/ros-client-types';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import { Service } from './http-service';

class ApprovalRequestsService extends Service {
  async getAllWithQuery(params: ApprovalRequestsControllerFindAllData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<ApprovalRequestResponseDto>>(
      `${this.endpoint}`,
      {
        params,
      },
    );
    return res.data;
  }

  async getOne(id: string) {
    const res = await this.httpClient.get<ApprovalRequestResponseDto>(`${this.endpoint}/${id}`);
    return res.data;
  }

  async approve(id: string) {
    const res = await this.httpClient.post<ApprovalRequest>(`${this.endpoint}/${id}/approve`);
    return res.data;
  }

  async reject(id: string, rejectionReason: string) {
    const res = await this.httpClient.post<ApprovalRequest>(`${this.endpoint}/${id}/reject`, {
      rejectionReason,
    });
    return res.data;
  }

  async withdraw(id: string) {
    const res = await this.httpClient.post<ApprovalRequest>(`${this.endpoint}/${id}/withdraw`);
    return res.data;
  }
}

export const approvalRequestsService = new ApprovalRequestsService('/approval-requests');
